import React, { useState, useEffect } from 'react'
import { HomeIcon, PencilIcon, BuildingLibraryIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import { 
  Typography,
  Card,
  CardBody,
  Input,
  Slider,
  Button,
  Spinner,
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel, 
  slider
} from "@material-tailwind/react";

import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Link,
  Navigate
} from "react-router-dom";

import { v4 as uuidv4 } from 'uuid';
import Wallet from './Wallet';
import MintDomain from './MintDomain';
import Explorer from './Explorer/Explorer';
import Profile from './Profile/Profile';
import IndexPage from './IndexPage';
import Test from './Test/Test';
import { useSelector, useDispatch } from 'react-redux';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import Mint from './Inscribe/Mint';
import MintP from './Inscribe/MintP';
import Marketplace from './Marketplace/Marketplace';
import Recover from './Recover/Recover';
import Admin from './Admin';
import MintStamps from './Inscribe/MintStamps';
import RecoverStamps from './Recover/RecoverStamps';
import toast, { Toaster } from 'react-hot-toast';
import Chat from '../components/Chat/Chat';
import MintPAToken from './Inscribe/MintPAToken';
import MintPATokenAdmin from './Inscribe/MintPATokenAdmin';
import MintPATokenTicker from './Inscribe/MintPATokenTicker';
import FractalTest from './Test/FractalTest';
import DmtPAToken from './Inscribe/DmtPAToken';
import DmtPATokenAdmin from './Inscribe/DmtPATokenAdmin';
import DmtPATokenTicker from './Inscribe/DmtPATokenTicker';
import DmtBlockpad from './Inscribe/DmtBlockpad';
import BlockdropBlockpad from './Inscribe/BlockdropBlockpad';
import BlockdropPAToken from './Inscribe/BlockdropPAToken';
import BlockdropPATokenAdmin from './Inscribe/BlockdropPATokenAdmin';
import BlockdropPATokenTicker from './Inscribe/BlockdropPATokenTicker';
import MintRunes from './Inscribe/MintRunes';
import Tap2Brc20 from './Tools/Tap2Brc20';
import Launchpad from './Tools/Launchpad';
import Dust20Inscribe from './Inscribe/Dust20Inscribe';
import UnlockUtxos from './Tools/UnlockUtxos';
import { useTranslation } from 'react-i18next';
import LanguageCard from '../components/LanguageCard';
import StampAssetDetail from './Stamp/StampAssetDetail';
import DomainName from './Inscribe/DomainName';
import Brc20PresaleAdmin from './Tools/Brc20PresaleAdmin';
import Brc20Presale from './Tools/Brc20Presale';
import Brc20Ido from './Tools/Brc20Ido';
import MenuBar from '../components/MenuBar';
import Brc20Claim from './Tools/Brc20Claim';
import Brc20ClaimTap from './Tools/Brc20ClaimTap';
import Dashboard from './Dashboard';
import NotFoundPage from './Error/NotFoundPage';
import MintAlkanes from './Alkanes/MintAlkanes';
import ExplorerAlkanes from './Alkanes/ExplorerAlkanes';
import ReferalCard from '../components/ReferalCard';
import LeaderboardAlkanes from './Alkanes/LeaderboardAlkanes';
import Op20Inscribe from './Inscribe/Op20Inscribe';
import Op20MarketplaceDetail from '../components/Marketplace/Op20/Op20MarketplaceDetail';
import ClockInSystemMint from './Alkanes/ClockInSystemMint';
import MezcalMarketplaceDetail from '../components/Marketplace/Mezcal/MezcalMarketplaceDetail';
import ClockInSystemReserve from './Alkanes/ClockInSystemReserve';
import AlkaneOrbitalMintTest from './Test/AlkaneOrbitalMintTest';
import AlkaneOrbitalContractMint from './Test/AlkaneOrbitalContractMint';
import MintAlkanesTest from './Alkanes/MintAlkanesTest';

import ReferalImg from '../assets/imgs/referal.png';

export default function Indexer() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [rightMenu, setRightMenu] = useState(false);
  const [menuIndex, setMenuIndex] = useState("");
  const [subMenuIndex, setSubMenuIndex] = useState("");
  const [showReferalCard, setShowReferalCard] = useState(false);
  const wallet = useSelector(state => state.wallet);

  const openRightMenu = () => {
    setRightMenu(true);
    setMenuIndex("");
    setSubMenuIndex("");
  };

  const closeRightMenu = () => {
    setRightMenu(false);
  };

  const handleShowReferalCard = () => {
    if (wallet.nostrOrdinalsAddress == "") {
      toast.error(t('Please connect your wallet'));
      return;
    }
    setShowReferalCard(true);
  }

  const [tab, setTab] = useState(0); //0: Wallet 1: Mint Domain 2: Explorer

  useEffect(() => {
    let tempTab = 1;
    switch(location.pathname) {
      case '/':
        tempTab = 0;
        break;
      case '/register':
        tempTab = 1;
        break;
      case '/explorer':
        tempTab = 2;
        break;
      case '/profile':
        tempTab = 3;
        break;
      case '/index':
        tempTab = 4;
        break;
      case '/tapzero':
        tempTab = 5;
        break;
      case '/marketplace':
        tempTab = 6;
        break;
      case '/istamps':
        tempTab = 7;
        break;
      case '/chat':
        tempTab = 8;
        break;
      case '/inscribe/prvauth':
        tempTab = 9;
        break;
      case '/inscribe/dmtprvauth':
        tempTab = 10;
        break;
      case '/inscribe/blockdrop':
        tempTab = 12;
        break;
      case '/mint/runes':
        tempTab = 13;
        break;
      case '/inscribe/dmtprvauth/runezero/blockpad':
        tempTab = 14;
        break;
      case '/tap2brc20':
        tempTab = 15;
        break;
      case '/launchpad':
        tempTab = 16;
        break;
      case '/inscribe/dust20':
        tempTab = 17;
        break;
      case '/unlockUtxos':
        tempTab = 18;
        break;
      case '/inscribe/src101':
        tempTab = 19;
        break;
      case '/ido/brc20/ᚠ':
        tempTab = 20;
        break;
      case '/presale/brc20/🜟':
        tempTab = 21;
        break;
      case '/presale/brc20/🝏':
        tempTab = 22;
        break;
      case '/alkanes/explorer':
        tempTab = 26;
        break;
      case '/alkanes/mint':
        tempTab = 25;
        break;
      case '/alkanes/leaderboard':
        tempTab = 27;
        break;
      case '/alkanes/clockinsystem':
        tempTab = 29;
        break;
      case '/inscribe/op_return':
        tempTab = 28;
        break;
      case '/trade/op_return':
        tempTab = 30;
        break;
      case '/trade/mezcal':
        tempTab = 31;
        break;
      case '/alkanes/clockinsystem/reserve':
        tempTab = 32;
        break;
      default:
        tempTab = 3;
        break;
    }
    setTab(tempTab);
  }, [location.pathname])
  
  const handleTab = (tab) => {
    setTab(tab);
    switch(tab) {
      case 0:
        navigate('/');
        break;
      case 1:
        navigate('/register');
        break;
      case 2:
        navigate('/explorer')
        break;
      case 3:
        navigate('/profile')
        break;
      case 4:
        navigate('/index')
        break;
      case 5:
        navigate('/tapzero')
        break;
      case 6:
        navigate('/trade')
        break;
      case 7:
        navigate('/istamps')
        break;
      case 8:
        navigate('/chat')
        break;
      case 9:
        navigate('/inscribe/prvauth')
        break;
      case 10:
        navigate('/inscribe/dmtprvauth')
        break;
      case 11:
        window.location.href = 'https://airdrop.bitcoinuniverse.io'
        break;
      case 12:
        navigate('/inscribe/blockdrop')
        break;
      case 13:
        navigate('/mint/runes')
        break;
      case 14:
        navigate('/inscribe/dmtprvauth/runezero/blockpad')
        break;
      case 15:
        navigate('/tap2brc20')
        break;
      case 16:
        navigate('/launchpad')
        break;
      case 17:
        navigate('/inscribe/dust20')
        break;
      case 18:
        navigate('/unlockUtxos')
        break;
      case 19:
        navigate('/inscribe/src101')
        break;
      case 20:
        navigate('/ido/brc20/ᚠ')
        break;
      case 21:
        navigate('/presale/brc20/🜟')
        break;
      case 22:
        navigate('/presale/brc20/🝏')
        break;
      case 23:
        navigate('/claim/brc20/🜷')
        break;
      case 24:
        navigate('/claim/brc20/tap')
        break;
      case 25:
        navigate('/alkanes/mint')
        break;
      case 26:
        navigate('/alkanes/explorer')
        break;
      case 27:
        navigate('/alkanes/leaderboard')
        break;
      case 28:
        navigate('/inscribe/op_return')
        break;
      case 29:
        navigate('/alkanes/clockinsystem')
        break;
      case 30:
        navigate('/trade/op20')
        break;
      case 31:
        navigate('/trade/mezcal')
        break;
      case 32:
        navigate('/alkanes/clockinsystem/reserve')
        break;
    }
  }
  return (
    <div className="flex flex-col gap-5 bg-background items-center w-full">
      <Header tab = {tab} handle = { handleTab} openRightMenu = {openRightMenu}/>
      <MenuBar tab = {tab} handle = { handleTab} openRightMenu = {openRightMenu} menuIndex = {menuIndex} setMenuIndex = {setMenuIndex} subMenuIndex = {subMenuIndex} setSubMenuIndex = {setSubMenuIndex} closeRightMenu = {closeRightMenu} rightMenu = {rightMenu}/>
      <Routes>
        <Route path="/register" element={<MintDomain />} />
        <Route path="/mint" element={<Navigate to="/register" replace />} />
        <Route path="/explorer" element={<Explorer />} />
        <Route path="/profile" element={<Profile />}/>
        <Route path="/profile/:id" element={<Profile />}/>
        <Route path="/index" element={<IndexPage />}/>
        <Route path="/index/runes/:param" element={<IndexPage />}/>
        <Route path="/_mint" element={<MintP />}/>
        <Route path="/___recover___" element={<Recover />}/>
        <Route path="/___istamps___" element={<RecoverStamps />}/>
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path="/tapzero" element={<Mint />}/>
        <Route path="/istamps" element={<MintStamps />}/>
        <Route path="/mint/runes" element={<MintRunes />}/>
        <Route path="/inscribe/prvauth" element={<MintPAToken />}/>
        <Route path="/inscribe/prvauth/:param" element={<MintPATokenTicker />}/>
        <Route path="/inscribe/prvauth/:param/admin" element={<MintPATokenAdmin />}/>
        <Route path="/inscribe/dmtprvauth" element={<DmtPAToken />}/>
        <Route path="/inscribe/dmtprvauth/:param/admin" element={<DmtPATokenAdmin />}/>
        <Route path="/inscribe/dmtprvauth/:param" element={<DmtPATokenTicker />}/>
        <Route path="/inscribe/dmtprvauth/:param/blockpad" element={<DmtBlockpad />}/>
        <Route path="/inscribe/blockdrop" element={<BlockdropPAToken />}/>
        <Route path="/stamp/asset/:param" element={<StampAssetDetail />}/>
        <Route path="/inscribe/blockdrop/:param/admin" element={<BlockdropPATokenAdmin />}/>
        <Route path="/inscribe/blockdrop/:param" element={<BlockdropPATokenTicker />}/>
        <Route path="/inscribe/blockdrop/:param/blockpad" element={<BlockdropBlockpad />}/>
        <Route path="/trade" element={<Marketplace />}/>

        <Route path="/trade/op_return" element={<Marketplace />}/>
        <Route path="/trade/op20" element={<Navigate to="/trade/op_return" replace />} />
        <Route path="/trade/mezcal" element={<Marketplace />}/>
        
        <Route path="/trade/op_return/:param" element={<Op20MarketplaceDetail />}/>
        <Route path="/trade/mezcal/:param" element={<MezcalMarketplaceDetail />}/>
        <Route path="/" element={<Wallet />} />
        <Route path="/_test" element={<Test />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />}/>
        <Route path="/terms-of-service" element={<TermsOfService />}/>
        <Route path="/___admin___" element={<Admin />} />
        <Route path="/chat" element={<Chat />}/>
        <Route path="/tap2brc20" element={<Tap2Brc20 />}/>
        <Route path="/launchpad" element={<Launchpad />}/>
        <Route path="/launchpad/:param" element={<Launchpad />}/>
        <Route path="/unlockUtxos" element={<UnlockUtxos />}/>
        <Route path="/fractalTest" element={<FractalTest />}/>
        <Route path="/inscribe/dust20" element={<Dust20Inscribe />}/>
        <Route path="/inscribe/dust20/:param" element={<Dust20Inscribe />}/>
        <Route path="/inscribe/src101" element={<DomainName />}/>
        <Route path="/ido/brc20/:param/admin" element={<Brc20PresaleAdmin />}/>
        <Route path="/ido/brc20/:param" element={<Brc20Ido />}/>
        <Route path="/presale/brc20/:param/admin" element={<Brc20PresaleAdmin />}/>
        <Route path="/presale/brc20" element={<Navigate to="/presale/brc20/🝏" replace />} />
        <Route path="/presale/brc20/:param" element={<Brc20Presale />}/>
        {/* <Route path="/claim/brc20/:param" element={<Brc20Claim />}/> */}
        <Route path="/claim/brc20/tap" element={<Brc20ClaimTap />}/>
        <Route path="/claim/brc20/🜷" element={<Brc20Claim />}/>
        <Route path="/alkanes/mint" element={<MintAlkanes />} />
        <Route path="/earn/:param" element={<MintAlkanes />}/>
        <Route path="/alkanes/mint/:param" element={<MintAlkanes />}/>
        <Route path="/alkanes/explorer" element={<ExplorerAlkanes />}/>
        <Route path="/alkanes/leaderboard" element={<LeaderboardAlkanes />}/>
        <Route path="/alkanes/clockinsystem" element={<ClockInSystemMint />}/>
        <Route path="/alkanes/clockinsystem/reserve" element={<ClockInSystemReserve />}/>

        <Route path="/inscribe/op_return" element={<Op20Inscribe />}/>
        <Route path="/inscribe/op20" element={<Navigate to="/inscribe/op_return" replace />} />

        <Route path="/inscribe/op_return/mint/:param" element={<Op20Inscribe />}/>
        <Route path="/inscribe/op_return/transfer/:param" element={<Op20Inscribe />}/>
        <Route path="/__OrbitalTest" element={<AlkaneOrbitalMintTest />}/>
        <Route path="/__ContractTest" element={<AlkaneOrbitalContractMint />}/>
        <Route path="/alkanes/mintTest" element={<MintAlkanesTest />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {/* <div className="text-white border-solid border-white border-[2px] p-3 cursor-pointer" onClick = {() => toast.success("I am okay!")}>Okay</div> */}
      {
        location.pathname == '/chat' ? <></> : <Footer />
      }
      <div className="flex flex-row justify-center items-center fixed bottom-3 right-3 w-10 h-10 rounded-full bg-primary hover:bg-primary-hover cursor-pointer shadow-lg" onClick = {() => handleShowReferalCard()}>
        <img src={ReferalImg} alt="referal" className="w-7 h-7" />
      </div>
      {showReferalCard && <ReferalCard setShowReferalCard = {setShowReferalCard} showReferalCard = {showReferalCard}/>}
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#000000',
            color: '#FFFFFF',
            marginTop: '50px'
          },
          iconTheme: {
            primary: '#f9099d',
          }
        }}      
      />
    </div>
  )
}
